import React from 'react';

import OldCTABlock from './OldCTA';
import CTABlock from './CTABlock';

const BlockCTA = (props) => {
  const { newBlock = false } = props;

  // We keep the old component for the OF and KP domains, until migrated.
  // https://uncinc.monday.com/boards/420919839/pulses/8926347948.
  if (!newBlock) {
    return <OldCTABlock {...props} />;
  }

  return <CTABlock {...props} />;
};

export default BlockCTA;
